import { Container, Text } from "@mantine/core";
import { HTML_PAGE_NOT_AVAILABLE } from "_constants";
import { PlayBingoGameLoader } from "bingo/play/components/PlayBingoGameLoader";
import PlayPronosticsV2View from "./PlayPronosticsV2View";
import { withDebug } from "common/debug/components/withDebug";
import { DEFAULT_WHITE_COLOR } from "../../../_graphic_design";
import { useSavedEvent } from "event/hooks/useSavedEvent";
import { useSavedPronosticV2 } from "pronosticsv2/hooks/useSavedPronostic";
import { usePronosticsV2 } from "pronosticsv2/hooks/usePronosticsV2";
import { useEffect, useState } from "react";
import { SubPlace } from "place/types/place.model";
import { useNavigate } from "react-router-dom";

function PlayPronosticsV2PresenterComponent() {
  //using hooks
  const navigate = useNavigate();
  const { pronosticV2, refetchPronosticV2 } = usePronosticsV2();
  const [subPlaceId, setSubPlaceId] = useState("0");

  //helper function
  const handlePronosticV2Refresh = () => {
    try {
      console.log("refetching pronosticV2");
      refetchPronosticV2();
    } catch (error) {
      console.error(error);
    }
  };

  //Data extraction from url
  const url = new URL(window.location.href);
  const pathSegments = url.pathname.split("/");
  const eventId = pathSegments[2];
  const currentUrl = window.location.pathname;
  const segments = currentUrl.split("/");
  const pronosticV2Id = segments[segments.length - 1];

  //data extraction using data extracted from url from local storage
  const [savedPronosticV2] = useSavedPronosticV2(pronosticV2Id!);
  const savedEvent = useSavedEvent(eventId || "")[0];

  useEffect(() => {
    // Retrieve subplaceid from local storage (only source)
    const redirector = localStorage.getItem("redirector");
    //console.log("redirector", redirector);

    if (redirector) {
      try {
        const redirectorData = JSON.parse(redirector);
        if (
          redirectorData.redirectTo === "pronosticsV2" &&
          redirectorData.subPlaceId &&
          pronosticV2?.commonSettings?.general?.moduleSettings?.place?.subPlaces?.some(
            (subPlace: SubPlace) => subPlace.id === redirectorData.subPlaceId
          )
        ) {
          console.log("hitted redirector");
          setSubPlaceId(redirectorData.subPlaceId);
          // Remove the redirector key after retrieval
        }
        localStorage.removeItem("redirector");
      } catch (error) {
        console.error("Failed to parse redirector data:", error);
      }
    }
  }, [pronosticV2]);

  console.log("subPlaceId", subPlaceId);

  let playerId: string;
  let partitionId: string;

  ({ playerId, partitionId } = savedEvent || {
    playerId: "",
    partitionId: "",
  });

  if (savedPronosticV2) {
    ({ playerId, partitionId } = savedPronosticV2);
  } else {
    ({ playerId, partitionId } = {
      playerId: "",
      partitionId: "",
    });
  }
  //pay load creation
  const payload = savedEvent?.playerInfo;

  useEffect(() => {
    if (!payload) {
      navigate("../../../");
    }
  }, [payload, navigate]);

  if (pronosticV2) {
    return (
      <PlayPronosticsV2View
        pronosticV2={pronosticV2}
        playerId={playerId}
        partitionId={partitionId}
        playerInfo={payload}
        subPlace={subPlaceId}
        refreshPronosticV2={handlePronosticV2Refresh}
      />
    );
  }

  if (!pronosticV2) {
    return (
      <Container pb={"lg"}>
        <PlayBingoGameLoader
          message={
            <Text
              className="text-2xl text-center "
              sx={{
                color: DEFAULT_WHITE_COLOR,
              }}
              dangerouslySetInnerHTML={{ __html: HTML_PAGE_NOT_AVAILABLE }}
            />
          }
        />
      </Container>
    );
  }

  // Handle the case where data is null but not loading
  return (
    <Container pb={"lg"}>
      <PlayBingoGameLoader
        message={
          <Text
            className="text-2xl text-center "
            sx={{
              color: DEFAULT_WHITE_COLOR,
            }}
            dangerouslySetInnerHTML={{ __html: HTML_PAGE_NOT_AVAILABLE }}
          />
        }
      />
    </Container>
  );
}

export const PlayPronosticsV2Presenter = withDebug(
  PlayPronosticsV2PresenterComponent
);
